import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";
import { FadeUp } from "@/components/site/Reveal";
import { CONTACT_EMAIL } from "@/data/site";
import { usePageMeta } from "@/hooks/usePageMeta";

const blocks = [
  {
    title: "Éditeur du site",
    text: "Le site Les Amis du Web est édité par l'équipe Les Amis du Web, spécialisée dans la création de sites internet sur mesure. Contact : " + CONTACT_EMAIL + ".",
  },
  {
    title: "Cookies & mesure d'audience",
    text: "Ce site utilise uniquement des cookies de mesure d'audience destinés à améliorer votre expérience de navigation. Aucune donnée n'est revendue à des tiers. Vous pouvez accepter ou refuser ces cookies via la bannière prévue à cet effet.",
  },
  {
    title: "Données personnelles",
    text: "Les informations transmises via le formulaire de demande (nom, coordonnées, description de projet) sont utilisées exclusivement pour étudier votre demande et vous recontacter. Elles ne sont jamais transmises à des tiers. Conformément au RGPD, vous pouvez demander la consultation, la modification ou la suppression de vos données en nous écrivant à " + CONTACT_EMAIL + ".",
  },
  {
    title: "Hébergement",
    text: "Le site est hébergé sur une infrastructure cloud sécurisée. Les données sont traitées dans le respect de la réglementation européenne en vigueur.",
  },
  {
    title: "Propriété intellectuelle",
    text: "L'ensemble des contenus de ce site (textes, visuels, réalisations présentées) est la propriété de Les Amis du Web. Toute reproduction sans autorisation préalable est interdite.",
  },
];

export default function Confidentialite() {
  usePageMeta({
    title: "Confidentialité & mentions légales — Les Amis du Web",
    description:
      "Politique de confidentialité, cookies de mesure d'audience et mentions légales du site Les Amis du Web, création de sites internet sur mesure.",
  });
  return (
    <div className="relative min-h-screen bg-[var(--bg-primary)]" data-testid="confidentialite-page">
      <Header />
      <main className="relative pt-36 pb-28">
        <div className="glow-orb w-[420px] h-[420px] bg-blue-600/12 -top-24 -left-32" />
        <div className="max-w-3xl mx-auto px-6 md:px-10 relative">
          <FadeUp>
            <p className="section-label mb-5">— Informations légales</p>
          </FadeUp>
          <FadeUp delay={0.08}>
            <h1 className="font-display font-extrabold text-4xl sm:text-5xl tracking-tight leading-[1.05]">
              Confidentialité & <span className="text-gradient">mentions légales.</span>
            </h1>
          </FadeUp>
          <div className="mt-12 flex flex-col gap-6">
            {blocks.map((b, i) => (
              <FadeUp key={b.title} delay={0.1 + i * 0.05}>
                <div className="card-surface rounded-2xl p-7">
                  <h2 className="font-display font-bold text-xl tracking-tight mb-3">{b.title}</h2>
                  <p className="text-[var(--text-secondary)] text-sm md:text-base leading-relaxed">{b.text}</p>
                </div>
              </FadeUp>
            ))}
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
